import React from 'react'
import { Typography, Row, Col, Input } from 'antd'
import Button from 'components/shared/button'

const { Title } = Typography

export default function ComingSoon() {
  return (
    <>
      <Title
        level={4}
        style={{
          height: '22px',
          fontWeight: '600',
          fontSize: '21px',
          lineHeight: '22px',
          alignItems: 'center',
          color: '#000000',
          margin: '32px 12px 16px 12px',
        }}
      >
        Calculator Coming Soon
      </Title>
      <div>
        <Input />
      </div>
      <div>
        <Input />
      </div>
      <div>
        <Input />
      </div>
      <Button
        size="large"
        type="primary"
        style={{ margin: '8px auto auto auto' }}
      >
        Calculator
      </Button>
      <Row>
        <Col span={24} style={{ color: '#595959', fontSize: '14px' }}>
          <Row
            span={24}
            style={{
              margin: '48px auto',
            }}
          >
            <Col
              span={24}
              style={{
                textAlign: 'center',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              THIS CALCULATOR IS UNDER CONSTRUCTION!
            </Col>
          </Row>
        </Col>
      </Row>
      <Title level={4} style={{ fontSize: '14px', marginTop: '16px' }}>
        Financial Calculator
      </Title>
    </>
  )
}
